import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class SearchService {

    // 2024-10-04 - Debra Frum - US26423 - PE - Search Accounts, Policies, Contacts - Solr Search
    // static search(searchRequestDTO, additionalHeaders = {}) {
    //     return JsonRPCService.send(
    //         getProxiedServiceUrl('search'),
    //         'search',
    //         [searchRequestDTO],
    //         additionalHeaders
    //     );
    // }

    // 2024-10-04 - Debra Frum - US26423 - PE - Search Accounts, Policies, Contacts - Solr Search
    static search(searchRequestDTO, queryOptionsDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('search'),
            'getPoliciesByFreeTextSearch',
            [searchRequestDTO, queryOptionsDTO],
            additionalHeaders
        );
    }

   static searchPartial(searchRequestDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('search'),
            'searchPartial',
            [searchRequestDTO],
            additionalHeaders
        );
    }
}
